'use client'

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import Link from "next/link";

const NotFound = () => {
  const [mounted, setMounted] = useState(false);
  const [pathname, setPathname] = useState<string>('');
  
  // Only call usePathname after mounting to prevent SSR issues
  const pathnameHook = usePathname();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      setPathname(pathnameHook);
    }
  }, [pathnameHook, mounted]);

  useEffect(() => {
    if (mounted && pathname) {
      console.error(
        "404 Error: User attempted to access non-existent route:",
        pathname,
      );
    }
  }, [pathname, mounted]);

  // Don't render until mounted to prevent SSR issues
  if (!mounted) {
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <div className="flex justify-center mb-6">
          <img 
            src="/saarthiq_symbol_logo.png"
            alt="SaarthiQ Logo" 
            className="h-16 w-auto mb-4"
          />
        </div>
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
        <Link href="/" className="text-blue-500 hover:text-blue-700 underline">
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
